import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TechDocs } from "@/components/tech/TechDocs";
import { Attendance } from "@/components/tech/Attendance";

const TABS = [["bast", "BAST"], ["survey", "Hasil Survey"], ["checklist", "Checklist Persiapan"], ["mreport", "Maintenance Report"], ["absen", "Absen Helper"]];

export default function Tech() {
  return (
    <div className="space-y-6" data-testid="tech-page">
      <div>
        <h1 className="font-heading text-3xl font-bold sm:text-4xl">Teknisi</h1>
        <p className="text-sm text-slate-500">BAST, survey, checklist persiapan, laporan maintenance & absensi helper.</p>
      </div>
      <Tabs defaultValue="bast">
        <TabsList className="h-auto flex-wrap justify-start">
          {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} data-testid={`tech-tab-${v}`}>{l}</TabsTrigger>)}
        </TabsList>
        {TABS.slice(0, 4).map(([v]) => <TabsContent key={v} value={v} className="pt-4"><TechDocs type={v} /></TabsContent>)}
        <TabsContent value="absen" className="pt-4"><Attendance /></TabsContent>
      </Tabs>
    </div>
  );
}
